/**
 * The Theme slice's loader, between a parsed `.tres` and `decode.ts`, called by
 * `processors/createThemeProcessor.ts`. It resolves the decoded font addresses.
 */
import { resourceFilePath } from '../../subResourcePath';
import { decodeThemeAddresses } from './decode';
/**
 * Resolves `ThemeAddresses` into a `ThemeResource` by awaiting `loadFont` for each
 * address, inside the Theme processor's async `loadDirectly`. Font refs resolve
 * through another processor, so the loader is injected.
 */
async function resolveThemeResource(addresses, loadFont) {
    const resolveFont = async (address) => address ? loadFont(address) : null;
    const defaultFont = await resolveFont(addresses.defaultFont);
    const fonts = {};
    await Promise.all(Object.entries(addresses.fonts).map(async ([type, byName]) => {
        const resolvedByName = {};
        await Promise.all(Object.entries(byName).map(async ([name, address]) => {
            const font = await loadFont(address);
            if (font)
                resolvedByName[name] = font;
        }));
        if (Object.keys(resolvedByName).length)
            fonts[type] = resolvedByName;
    }));
    return {
        defaultFont,
        defaultFontSize: addresses.defaultFontSize,
        fonts,
        fontSizes: addresses.fontSizes,
        styles: addresses.styles,
        icons: addresses.icons,
        colors: addresses.colors,
        constants: addresses.constants,
        typeVariations: addresses.typeVariations,
        properties: addresses.properties,
        resources: addresses.resources,
    };
}
/** The `ThemeResource` that `section`, loaded from `path`, decodes to. */
export async function buildThemeResource(path, { file, properties }, loadFont) {
    const addresses = decodeThemeAddresses(resourceFilePath(path), properties, file.extResources, file.subResources);
    return resolveThemeResource(addresses, loadFont);
}
//# sourceMappingURL=loadTheme.js.map